import { Component, EventEmitter, Input, Output, OnInit } from '@angular/core';
import { MethodApi } from '../../api/api-request';
import { ToastrService } from 'ngx-toastr';
import { TranslateService } from '@ngx-translate/core';
import { MatDialog } from '@angular/material/dialog';
import { DialogItemSizeComponent } from '../dialog-item-size/dialog-item-size.component';
import { ADMIN, Constants, StockItem, ItemConfig, Option, OPTION } from '@co-assist/library';
import { ImagesService } from 'app/services/utilities/images.service';
@Component({
    selector: 'app-personalize',
    templateUrl: './personalize.component.html',
    styleUrls: ['./personalize.component.scss']
})
export class PersonalizeComponent implements OnInit {
    readonly B2C_BUSINESS = ADMIN.BUSINESS_TYPE.B2C;

    identificationNumber: string = '';
    current_page: number = 0;
    ariane: Array<string> = ['first', 'identificationNumber', 'selectItem', 'selectProcess'];
    @Input() options: Option[];
    @Input() itemConfig: ItemConfig;
    @Output() currentSection: EventEmitter<{ section, direction }> = new EventEmitter<{ section, direction }>();
    @Output() watchEmitter: EventEmitter<any> = new EventEmitter<any>();
    @Output() optionEmitter: EventEmitter<Array<Option>> = new EventEmitter<Array<Option>>();
    constructor(
        public imgService: ImagesService,
        private api: MethodApi,
        private toastr: ToastrService,
        private translate: TranslateService,
        private dialog: MatDialog
    ) { }

    ngOnInit() {
        this.identificationNumber = this.itemConfig?.moduleID || '';
    }

    isTelecareSelected(): boolean {
        return this.options.find(opt => opt.name === Constants.Invoice.LINE_CODE.SERVICETELECARE) !== undefined;
    }

    next(alreadyOwn: boolean): void {
        this.itemConfig = new ItemConfig({ alreadyOwn });
        this.continue('first');
    }

    nextProcess(chooseTelecare: boolean): void {
        if (chooseTelecare) {
            this.options.push(new Option({
                name: Constants.Invoice.LINE_CODE.SERVICETELECARE,
                type: OPTION.OptionType.RENTING,
                equipment: OPTION.OptionEquipment.SERVICE,
                unitPrice: 10,
                shippingPrice: 0,
                qty: 1
            }));
        } else {
            this.options = this.options.filter(opt => opt.name !== Constants.Invoice.LINE_CODE.SERVICETELECARE);
        }
        this.optionEmitter.emit(this.options);
        this.continue('selectProcess');
    }

    identificationNumberIsValid() {
        this.api.getModuleAvailability({ moduleID: this.identificationNumber }).subscribe(isValid => {
            if (isValid) {
                this.itemConfig.moduleID = this.identificationNumber;
                this.continue('identificationNumber');
            } else {
                this.toastr.error(this.translate.instant('REGISTRATION.STEP.PERSONALIZE.INVALID_IDENTIFICATION_NUMBER'));
            }
        });
    }

    getIndex(page: string) {
        return this.ariane.indexOf(page);
    }

    previous(page: string) {
        if (page === 'identificationNumber' || page === 'selectItem') {
            this.currentSection.emit({ section: 'personalize', direction: 'back' });
        } else {
            this.current_page = this.ariane.indexOf(page) - 1;
        }
    }

    continue(page: string, dropWatch: boolean = false) {
        // dropWatch => first the user select an item, then go back and take the option "choose later"
        if (dropWatch) {
            this.itemConfig.reference = null;
            this.itemConfig.title = null;
            this.itemConfig.size = null;
        }
        if (page === 'identificationNumber' || page === this.ariane[this.ariane.length - 1]) {
            this.watchEmitter.emit(this.itemConfig);
            this.currentSection.emit({ section: 'personalize', direction: 'continue' });
        } else if (page === 'first' && !this.itemConfig.alreadyOwn) {
            this.current_page = this.ariane.indexOf(page) + 2;
        } else {
            this.current_page = this.ariane.indexOf(page) + 1;
        }
    }

    selectItem(item: StockItem) {
        this.itemConfig.reference = item.reference;
        this.itemConfig.title = item.fr.title;
        switch (item.dialogOption) {
            case Constants.Stock.DialogOption.WATCHBAND_SIZE:
                this.handleWatchBandSize();
                break;
            default:
                this.continue('selectItem');
        }
    }

    private handleWatchBandSize() {
        const dialogRef = this.dialog.open(DialogItemSizeComponent, {
            disableClose: true,
            width: '600px',
            data: { itemConfig: this.itemConfig }
        });
        dialogRef.afterClosed().subscribe(result => {
            if (result) {
                this.itemConfig.size = result;
                this.continue('selectItem');
            }
        });
    }
}
